export default "__VITE_ASSET__DXZGvIOg__"